import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"
import { jwtDecode } from "jwt-decode"
import { API_URL } from "../../config"



const initialState = {
    isAuthenticated: false,
    user: null,
    isLoading: true, // Définir sur true au chargement initial
    userList: [],
};

export const registerUser = createAsyncThunk('/auth/register',
    async (formData) => {
        const response = await axios.post(
            API_URL + "/api/admin/auth/register",
            formData,
            {
                withCredentials: true
            });
        return response.data;
    }
);

export const loginUser = createAsyncThunk(
    '/auth/login',
    async (formData) => {
        console.log("login", "request");
        const response = await axios.post(
            API_URL + "/api/admin/auth/login",
            formData,
            {
                withCredentials: true
            });
        return response.data;
    }
);

export const logoutUser = createAsyncThunk(
    "/auth/logout",
    async () => {
        console.log("logout", "request");
        const response = await axios.post(
            API_URL + "/api/admin/auth/logout",
            {},
            {
                withCredentials: true,
            }
        );

        return response.data;
    }
);

export const checkAuth = createAsyncThunk(
    'auth/check-Auth',
    async () => {
        const response = axios.get(
            API_URL +'/api/admin/auth/check-auth',
            {
                withCredentials: true,
                headers: {
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const fetchAllUsers = createAsyncThunk(
    '/auth/getAll',
    async () => {        
        console.log("getAllUsers", "request");
        const result = await axios.get(
            API_URL + `/api/admin/auth/getAll`,
        );

        return result?.data
    }
);

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setUser: (state, action) => {

        },
        loginUser: (state) => {
            state.user = null;
            state.isAuthenticated = false;
            localStorage.removeItem("token");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(registerUser.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(registerUser.fulfilled, (state, action) => {
                state.isAuthenticated = false;
                state.user = null;
                state.isLoading = false;
            })
            .addCase(registerUser.rejected, (state, action) => {
                state.isAuthenticated = false;
                state.user = null;
                state.isLoading = false;
            })
            .addCase(loginUser.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.isLoading = false;
                const token = action.payload.token;
                if (token) {
                    state.user = jwtDecode(token);
                    state.isAuthenticated = true;
                    localStorage.setItem("token", token);
                } else {
                    state.user = null;
                    state.isAuthenticated = false;
                }
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.isAuthenticated = false;
                state.user = null;
                state.isLoading = false;
            })
            .addCase(checkAuth.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(checkAuth.fulfilled, (state, action) => {
                state.isLoading = false;
                const token = localStorage.getItem("token");
                if (token) {
                    state.user = jwtDecode(token);
                    state.isAuthenticated = true;
                } else {
                    state.user = null;
                    state.isAuthenticated = false;
                }
            })
            .addCase(checkAuth.rejected, (state) => {
                state.isLoading = false;
                state.user = null;
                state.isAuthenticated = false;
            })
            .addCase(logoutUser.fulfilled, (state) => {
                state.isLoading = false;
                state.user = null;
                state.isAuthenticated = false;
                localStorage.removeItem("token");
            })
            .addCase(fetchAllUsers.pending, (state, action) => {
                state.isLoading = true;
                console.log("pending");
            })
            .addCase(fetchAllUsers.fulfilled, (state, action) => {
                console.log(action.payload);
                state.isLoading = false;
                state.userList = action.payload.data;
            }).addCase(fetchAllUsers.rejected, (state) => {
                console.log("rejected");
                state.isLoading = false;
                state.userList = [];
            })

    },
});


export const { setUser } = authSlice.actions;

export default authSlice.reducer

